import React, {useState} from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import Inputfield from '../InputField/Inputfield'
import Radiofield from '../Radiofield/Radiofield'
import '../Addemployee/addemployee.css'
import './addcountry.css'
import axios from 'axios'
import { useCookies } from 'react-cookie';


const AddCountry = ({sendnotice, empselect, params}) => {
    const API = 'https://staging.sabrecwa.com/staff'

    let newstaffArray = []

    empselect.allStaffs.map(staffObj => (
      newstaffArray.push({ID: staffObj.ID, name: staffObj.first_name + ' ' + staffObj.last_name})
    ))
    const [cookies] = useCookies(['Token']);
    const [values, setValues] = useState({
      countryname: '',
      countryhead: '',
    })

    const handleSubmit = () =>{
        // Submit Data
        if(params.id !== undefined || params.id > 0){
            // console.log("edit command")
            UpdateRequest(params.id)
        } else{
            // console.log("normal open")
            UpdateRequest(undefined)
        }
    }

    const UpdateRequest = async(props) =>{
        // setConfirmload(true)
        sendnotice({
          action: "load",
          text: 'Sending Data...'
        })
        try {
          var config = {
            method: 'POST',
            url: `${API}/hr/create/country`,
            data: {
              name: values.countryname,
              countryhead: 0
              // countryhead: values.countryhead
            },
            headers: { 
              Authorization: "Bearer " + cookies.Token
            }
          };
      
          await axios(config).then((response) => {
          console.log(response.data);
          if(response.data.success === false){
            sendnotice({
              action: "notload",
              text: response.data.message
            })
          }});
        } catch(e){
          if(e.message.includes('401')){
            // catch error
          } else{
            // catch error
          }
        }
    }

    const handleCountryname = (incoming) =>{
        setValues({...values, countryname: incoming})
    }

    const handleCountryhead = (incoming) =>{
        setValues({...values, countryhead: incoming})
    }

    const handleClose = () =>{
      sendnotice({
        action: "close",
        text: ''
    })
    }

  return (
    <div className='overlay-container'>
            <div className='overlay-addemployee-container'>
                <div className='top-container-apprais-notif'>
                    <span>ADD NEW COUNTRY</span>
                    <AiOutlineCloseCircle id='closeIcon-notifc' onClick={handleClose}/>
                </div>

                <div className='top-addemployee-container-body'>
                    <div className='addemployee-addrow'>
                        <div className='addemployee-addrow-cola'>
                            <Inputfield personname={handleCountryname} fieldlabel="Country" placehold="Enter Country here..." typeid="text"/>
                        </div>
                    </div>
                    {/* <div className='addemployee-addrow'>
                        <div className='addemployee-addrow-cola'>
                            <Inputfield EmployeeJson={newstaffArray} unithead={handleCountryhead} fieldlabel="Country Director" placehold="Select Director..." typeid="headsdropdwn"/>
                        </div>
                    </div> */}
                    <div className='top-addemployee-submit-row'>
                        <button id='broadcast-buttn' onClick={handleSubmit}>SUBMIT</button>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default AddCountry